import React from 'react'

import { Column } from '../../../../components/layouts/columns'
import { Page } from '../../../../components/layouts/page'
import { Button } from '../../../../components/ui/button'
import { PathDoc } from '../../../../router/docs'
import { VERSION } from '../../../../configs/textNotifications'

export const ClientInformations = () => {
  return (
    <>
      <Page.Section className="is-fullheight-with-navbar">
        <Column.Root>
          <Column.Content>
            <p className="subtitle is-size-5">
              <strong>Keap Staff</strong>
            </p>
            <p className="has-text-grey">Version {VERSION}</p>
          </Column.Content>
        </Column.Root>

        <Column.Root className="mt-6">
          <Column.Content>
            <p className="has-text-grey">
              <strong>Suporte Técnico</strong>
            </p>
            <Button.A>Acessar</Button.A>
          </Column.Content>
        </Column.Root>

        <Column.Root className="mt-6">
          <Column.Content>
            <p className="has-text-grey">
              <strong>Area Financeira</strong>
            </p>
            <Button.A>Acessar</Button.A>
          </Column.Content>
        </Column.Root>

        <Column.Root className="mt-6">
          <Column.Content>
            <p className="has-text-grey">
              <strong>Documentação Técnica</strong>
            </p>
            <Button.A link={PathDoc.ClientIntro} openNew>
              Acessar
            </Button.A>
          </Column.Content>
        </Column.Root>
      </Page.Section>
    </>
  )
}
